export type SilentAuthError = Error & { isSilent: true };

export const isSilentAuthError = (error: unknown): error is SilentAuthError =>
  error instanceof Error &&
  (error as SilentAuthError).isSilent === true;
